// extracted by mini-css-extract-plugin
module.exports = {"row":"OdnFooter_row__2CnEZ","button":"OdnFooter_button__OPnA6","button-ltr":"OdnFooter_button-ltr__3kayP"};